import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import { Tab, Tabs, AppBar, Slide } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import Toolbar from '@material-ui/core/Toolbar'
import CloseIcon from '@material-ui/icons/Close'
import { TabPanel, a11yProps } from '../../sharedComponents/TapPanel'
import TabField from '../TabField'
import { useStyles } from './styles'

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />)

export default function DialogForm(props) {
  const { open, field, fields, handleOpenDialog, onSaveField, onChangeField, onClearField, addFieldIn } = props

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const classes = useStyles()

  const [value, setValue] = React.useState(0)

  const onChangeGroup = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Dialog
      id="modalForm"
      fullScreen={fullScreen}
      open={open}
      maxWidth="md"
      TransitionComponent={Transition}
      aria-labelledby="responsive-dialog-title"
    >
      <AppBar centered="true" className={classes.appBar}>
        <Toolbar>
          <IconButton onClick={handleOpenDialog} edge="start" color="inherit" aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={onChangeGroup}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Individual" {...a11yProps(0)} />
          <Tab label="Intervalo" {...a11yProps(1)} />
          <Tab label="Excluir" {...a11yProps(2)} />
          <Tab label="Excluir Intervalo" {...a11yProps(3)} />
        </Tabs>
      </AppBar>
      <DialogContent>
        <DialogContentText>
          <hr />
          <br />
          <div id="header" className={classes.fieldListHeader}>
            {value === 1 || value === 3 ? null : <h3>Condición</h3>}
            <h3>Desde</h3>
            {value === 0 || value === 2 ? null : <h3>Hasta</h3>}
          </div>
          <hr />
          <TabPanel value={value} index={0}>
            <TabField
              array="individual"
              fields={fields}
              field={field}
              input1="condicion"
              input2="desde"
              isCondition
              onChangeField={onChangeField}
              onClearField={onClearField}
              addFieldIn={addFieldIn}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TabField
              array="intervalo"
              field={field}
              fields={fields}
              input1="desde"
              input2="hasta"
              isCondition={false}
              onChangeField={onChangeField}
              onClearField={onClearField}
              addFieldIn={addFieldIn}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <TabField
              array="excluir"
              field={field}
              fields={fields}
              input1="condicion"
              input2="desde"
              isCondition
              onChangeField={onChangeField}
              onClearField={onClearField}
              addFieldIn={addFieldIn}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <TabField
              array="excluir_intervalos"
              field={field}
              fields={fields}
              input1="desde"
              input2="hasta"
              isCondition={false}
              onChangeField={onChangeField}
              onClearField={onClearField}
              addFieldIn={addFieldIn}
            />
          </TabPanel>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSaveField} varian="contained" color="primary">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
